module.exports = __webpack_public_path__ + "img/iPhone12ProMax.6d3380d4.png";